"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.DateUtils = void 0;
class DateUtils {
    static getBasis(date) {
        let baseDate = new Date(date);
        baseDate.setHours(0, 0, 0, 0);
        return baseDate;
    }
    static difference(firstDate, secondDate) {
        return firstDate.getTime() - secondDate.getTime();
    }
}
exports.DateUtils = DateUtils;
